document.addEventListener('DOMContentLoaded', () => {
    // Pobieramy wszystkie elementy FAQ
    const faqItems = document.querySelectorAll('.faq-item');

    faqItems.forEach((item) => {
        // Pobieramy pytanie w danym elemencie FAQ
        const question = item.querySelector('.faq-item-question');

        if (question) {
            // Dodajemy event listener do pytania
            question.addEventListener('click', () => {
                // Sprawdzamy, czy element już ma klasę "open"
                if (item.classList.contains('open')) {
                    // Jeśli tak, usuwamy klasę
                    item.classList.remove('open');
                } else {
                    // Usuwamy klasę "open" z innych elementów FAQ
                    faqItems.forEach((faq) => faq.classList.remove('open'));

                    // Dodajemy klasę "open" do aktualnego elementu
                    item.classList.add('open');
                }
            });
        }
    });
});
